import { useState } from "react";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { ExecutiveProfile } from "../components/ExecutiveProfile";
import { BrandMarquee } from "../components/Marquee";
import { Entrance } from "../components/Entrance";
import { About } from "../components/About";
import { Framework } from "../components/Framework";
import { Vision } from "../components/Vision";
import { Advisory } from "../components/Advisory";
import { Academy } from "../components/Academy";
import { Products } from "../components/Products";
import { Insights, Speaking } from "../components/Insights";
import { Global } from "../components/Global";
import { Newsletter } from "../components/Newsletter";
import { Lifestyle } from "../components/Lifestyle";
import { ExecutiveClub } from "../components/ExecutiveClub";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { BoardCompass } from "../components/BoardCompass";
import { BookingModal } from "../components/BookingModal";

export default function Home() {
  const [booking, setBooking] = useState(false);
  const openBooking = () => setBooking(true);

  return (
    <div className="bg-white">
      <Nav onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <ExecutiveProfile />
        <BrandMarquee />
        <Entrance />
        <About />
        <Framework />
        <Vision />
        <Advisory onBook={openBooking} />
        <Academy />
        <Products />
        <Insights />
        <Speaking />
        <Global />
        <Newsletter />
        <Lifestyle />
        <ExecutiveClub />
        <Contact onBook={openBooking} />
      </main>
      <Footer onBook={openBooking} />
      <BoardCompass />
      <BookingModal open={booking} onClose={() => setBooking(false)} />
    </div>
  );
}
